import { api, ApiError } from "../api.js";
import { h, fmtDate } from "../ui.js";
import type { App } from "../main.js";

export function friendsView(app: App): HTMLElement {
  const list = h("ul", { class: "list" }, h("li", { class: "dim" }, "Loading…"));
  const input = h("input", { class: "input", type: "text", maxlength: "16", placeholder: "friend's handle", autocomplete: "off" });
  const msg = h("div");
  const load = () => api.friends().then(({ friends }) => list.replaceChildren(...(friends.length ? friends.map((f) =>
    h("li", {},
      h("span", { class: `dot ${f.status === "accepted" ? "" : ""}` }),
      h("span", { class: "grow" }, f.handle ? h("a", { href: `/profile/${f.handle}` }, f.handle) : h("span", { class: "dim" }, "(no character this era)")),
      f.status === "pending_in" ? h("button", { class: "btn", onclick: async () => { await api.friendAccept(f.account_id); void load(); } }, "Accept") : null,
      f.status === "pending_out" ? h("span", { class: "badge" }, "sent") : null,
      f.status === "accepted" ? h("span", { class: "dim mono-num" }, fmtDate(f.since)) : null,
      h("button", { class: "btn danger", onclick: async () => { await api.friendRemove(f.account_id); void load(); } }, f.status === "accepted" ? "Remove" : "Cancel"),
    )) : [h("li", { class: "dim" }, "No friends yet. Add someone by handle.")])));
  void load();
  return h("div", { class: "stack" },
    h("div", { class: "panel" },
      h("h1", {}, "Friends"),
      h("form", { onsubmit: async (e: Event) => { e.preventDefault(); try { await api.friendRequest(input.value.trim()); input.value = ""; msg.replaceChildren(); void load(); } catch (err) { msg.replaceChildren(h("div", { class: "msg error" }, err instanceof ApiError ? err.message : "error")); } } },
        h("div", { class: "row" }, h("div", { class: "grow" }, input), h("button", { class: "btn", type: "submit" }, "Add"))),
      msg,
      list,
      h("p", { class: "dim", style: "font-size:11px" }, "Presence (online / in a run) lights up once the game reports it."),
    ),
  );
  void app;
}
